import { BaseDeviceWrapper } from "./BaseDeviceWrapper";
import image from "images/devices/keon-promotion.png";

const serviceUuid = "00001900-0000-1000-8000-00805f9b34fb";
// UUIDs aligned with Keon WiFi BLE specification
// 0x1800 - motor command characteristic
// 0x2a19 - battery status characteristic
const statusCharacteristicUuid = 0x2a19;
const characteristicUuid = 0x1800;

const names = ["KEON WIFI"];

const KEON_STROKE_TIME = 275;

/**
 * Create a device wrapper over the Web Bluetooth device object
 * @param {obj} webBleDevice - Web Bluetooth device object
 */
export default class KeonWifi extends BaseDeviceWrapper {
  constructor(device) {
    super(device, serviceUuid, characteristicUuid, image);
    this.moveInterval = null;
  }

  static get deviceNames() {
    return names;
  }

  static get services() {
    return [serviceUuid];
  }

  get companyName() {
    return "Kiiroo";
  }

  async connect() {
    try {
      const result = await super.connect(
        this.getBatteryCharacteristic.bind(this)
      );
      // Move Keon to the movement mode
      await this.motorChar.writeValue(new Uint8Array([0x00]));
      return result;
    } catch (e) {
      console.log("Error connecting to KeonWifi device", e);
      return Promise.reject("Error connecting to KeonWifi device: " + e);
    }
  }

  async getBatteryCharacteristic() {
    this.statusChar = await this.sensorService.getCharacteristic(
      statusCharacteristicUuid
    );
  }

  async disconnect() {
    clearInterval(this.moveInterval);
    this.moveInterval = null;
    await super.disconnect();
  }

  async moveTo(position, speed) {
    const pos = Math.max(0, Math.min(99, Math.round(position)));
    const spd = Math.max(0, Math.min(99, Math.round(speed)));
    await this.motorChar.writeValue(new Uint8Array([0x03, 0x01, spd, pos]));
  }

  async writePauseValue() {
    await this.motorChar.writeValue(new Uint8Array([0x00]));
  }

  async writeMovementBetween(minPosition, maxPosition, speed) {
    const min = Math.max(0, Math.min(99, Math.round(minPosition)));
    const max = Math.max(0, Math.min(99, Math.round(maxPosition)));
    const spd = Math.max(0, Math.min(99, Math.round(speed)));

    await this.motorChar.writeValue(
      new Uint8Array([0x04, 0x00, spd, min, max])
    );
  }

  async write(speedPercentage) {
    clearInterval(this.moveInterval);
    this.moveInterval = null;
    if (speedPercentage === 0) {
      return;
    }

    const delay = Math.floor(KEON_STROKE_TIME / (speedPercentage / 100));
    let pos = 0;
    this.moveInterval = setInterval(() => {
      pos = pos ? 0 : 99;
      this.moveTo(pos, speedPercentage);
    }, delay);

    await this.moveTo(0, speedPercentage);
  }

  async getBattery() {
    const data = await this.statusChar?.readValue();
    // Battery level characteristic (0x2a19) exposes a single byte at offset 0
    return data?.getUint8(0);
  }
}
